<template>
  <div>

    <!-- PREVIEW IMAGE - BEGIN -->
    <preview-component ref="previewFile" :url="getUrl(previewFile.file, false)" :alt="previewFile.file.name"
                       :file="previewFile.file"></preview-component>
    <!-- PREVIEW IMAGE - END -->

    <modal-component :show="modalShow" ref="modalFileMananger" style="z-index: 10007" width="80%" height="90%" minWidth="780px">

      <div slot="body" class="file-mananger-container">
        <div class="file-mananger--navbar">
          <div class="file-mananger--navbar-menu">
            <div class="file-mananger--navbar--tab" v-for="(tab,index) in tabsFolders" :key="index"
                 :class="{'active' : tab.name === active}" :ref="`list-${tab.name}`"
                 @click.prevent="chooseTab(tab.name, tab)">
              {{ $t(`ct-tab-file-${typePopUp.toLowerCase()}-${tab.name}`)}}
            </div>
          </div>
          <div class="file-mananger--upload">
            <div class="files-container-upload">
              <span>{{ $t(`ct-helper-type-files-accept-${typePopUp.toLowerCase()}`)}}</span>
              <template v-if="type && accept">
                <div class="upload-area">
                  <div class="file-upload">
                    <div class="input-wrapper">
                      <input id="file-upload-input" type="file" name="file" class="file-upload-input"
                             multiple="multiple" ref="input-files" @change="onChangeFile" :accept="accept.accept">
                      <label
                        for="file-upload-input" class="file-upload-label">
                        <div>{{$t('ct-select-file')}}</div>
                      </label>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>

        <!-- FILTER HEADER - BEGIN -->
        <div class="files-container-header">
          <div>
            <form class="popup-files-options-search">
              <button type="submit" class="btn">
                <font-awesome-icon :icon="['fa', 'search']"/>
              </button>
              <input type="text" :placeholder="$t('ct-search')" class="form-control" v-model="filters.search"
                     @keyup="searchFile">
            </form>
          </div>

          <div>
            <div class="popup-files-options-order-type">
              <button class="btn btn-option-file" :class="{'active': this.filters.order === 'date'}"
                      @click.prevent="setFilter('order','date', true)">
                <i class="icon ct-icon-clock-outline"/>
              </button>
              <button class="btn btn-option-file" :class="{'active': this.filters.order === 'asc'}"
                      @click.prevent="setFilter('order','asc', true)">
                <!--                <font-awesome-icon :icon="['fas', 'icon-sort-alpha-up']"/>-->
                <i class="icon ct-icon-sort-alpha-up"/>
              </button>
              <button class="btn btn-option-file" :class="{'active': this.filters.order === 'desc'}"
                      @click.prevent="setFilter('order','desc', true)">
                <!--                <font-awesome-icon :icon="['fas', 'sort-alpha-down']"/>-->
                <i class="icon ct-icon-sort-alpha-down"/>
              </button>
            </div>

            <div class="popup-files-options-view-type">
              <button class="btn btn-option-file" :class="{'active': this.filters.typeView === 'th'}"
                      @click.prevent="setFilter('typeView','th')">
                <i class="icon ct-icon-th"/>
              </button>
              <!--              <button class="btn btn-option-file" :class="{'active': this.filters.typeView === 'th-large'}"-->
              <!--                      @click.prevent="setTypeView('th-large')">-->
              <!--                <font-awesome-icon :icon="['fa', 'th-large']"/>-->
              <!--              </button>-->
              <button class="btn btn-option-file" :class="{'active': this.filters.typeView === 'th-list'}"
                      @click.prevent="setFilter('typeView','th-list')">
                <!--                <font-awesome-icon :icon="['fa', 'th-list']"/>-->
                <i class="icon ct-icon-th-list"/>
              </button>
            </div>

            <template v-if="active === 'user'">
              <div class="popup-files-options-file">
                <button class="btn btn-option-file move-icon" :class="{'active': canMoveFiles}" @click.prevent="openMoveFiles">
                  <!--                  <font-awesome-icon :icon="['fas', 'arrows-alt']"/>-->
                  <i class="icon ct-icon-folder-move"/>
                </button>
                <button class="btn btn-option-file trash-icon" :class="{'active': canMoveFiles}"
                        @click.prevent="confirmDelete({'files': filesSelectedList}, 'files')">
                  <font-awesome-icon :icon="['far', 'trash-alt']"/>
                </button>
              </div>
            </template>
          </div>
        </div>
        <!-- FILTER - END -->

        <!-- CONTAINER IMAGES - BEGIN -->
        <div class="file-mananger--file-container">
          <div class="files-container-aside">
            <div class="files-container-navbar">
              <ul class="files-list-directories">
                <li ref="directory-all" @click.prevent="changeDirectories('all')" class="files-list-directories-item"
                    :class="{'active' : tabActive.directoryActive === 'all' }">
                  <span><i class="icon " :class="tabActive.directoryActive === 'all' ? 'ct-icon-folder-open': 'ct-icon-folder'"></i> {{ $t('ct-all-files')}}</span>
                </li>
                <li v-for="(directory, index) in tabActive.directories" :key="index" class="files-list-directories-item"
                    :ref="`directory-${directory.id}`"
                    :class="{'active' : tabActive.directoryActive === directory.id }">
                  <span @click="changeDirectories(directory.id)"><i class="icon" :class="tabActive.directoryActive === directory.id ? 'ct-icon-folder-open': 'ct-icon-folder'"/> {{ directory.name }} </span>
                  <div class="files-list-directories-item-options" :class="{ 'system-list' :  active === 'user' }"
                       v-if="active === 'user'">
                    <span @click.prevent="editDirectory(directory)"><font-awesome-icon :icon="['far', 'edit']"/></span>
                    <span @click.prevent="confirmDelete(directory, 'directory')"><font-awesome-icon
                      :icon="['far', 'trash-alt']"/></span>
                  </div>
                </li>
              </ul>
              <div class="files-list-footer" v-if="active === 'user'">
                <button class="btn-new-file" @click.prevent="newDirectory()">
                  <font-awesome-icon
                    :icon="['fas', 'plus']"/>
                  <span>{{ $t('ct-new-directory')}}</span>
                </button>
              </div>
            </div>
          </div>

          <div class="files-container-content" v-on:scroll="handleScroll" ref="containerContent">

            <div class="files-container-content-container" v-for="(tab,index) in tabsFolders" :key="index"
                 :data-group="tab.name" v-show="active === tab.name">
              <div class="files-container-content-image"
                   v-if="active === tab.name && filters.typeView === 'th' && (filesFilter.length !== 0|| filesPreview.length !== 0)">
                <div class="files-container-content--box-image container-preview" v-if="filesPreview"
                     v-for="(file, index) in filesPreview">
                  <div class="files-container-content--box-image-overlay" :class="{'is-error': file.error}"
                       style="opacity:1">
                    <div class="files-preview-remove" v-if="file.error" style="opacity:1"
                         @click.prevent="removeFilePreview(file)">
                      <font-awesome-icon :icon="['fas', 'times']"/>
                    </div>
                    <div class="files-preview-progress">
                      <div class="files-preview-progress-error" v-if="file.error">
                        <p>{{file.error}}</p>
                      </div>
                      <div class="progress" v-if="file.uploadPercentage">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                             aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"
                             :style="`width: ${file.uploadPercentage}%`"></div>
                      </div>
                    </div>
                    <div>

                    </div>
                  </div>
                  <div class="image-bg" v-if="file.base64"
                       v-bind:style="{'background-image': 'url(' + file.base64 +')',}"></div>
                  <span
                    class="title-image">{{ file.name.length > 30 ? file.name.substring(0,30) + '...' : file.name  }}</span>
                </div>
                <div class="files-container-content--box-image" v-for="(file, index) in filesFilter"
                     v-if="index <= tab.limitImage" :key="index"
                     :class="{'is-selected' : filesSelected.indexOf(file.id) > -1, 'is-selected-mutiple' : getIsCrtl(file) }"
                     @click="chooseImage(index, file, $event)">
                  <!--                     :class="{'not-has-name' : active !== 'user'}" -->
                  <div class="files-container-content--box-image-overlay">
                    <div class="selected-mutiple">
                      <font-awesome-icon :icon="['fas', 'check']"/>
                    </div>
                    <div>
                        <span v-if="active === 'user'" @click.prevent="editFile(file)"><font-awesome-icon
                          :icon="['far', 'edit']"/></span>
                      <span v-if="active === 'user'" @click.prevent="editorImage(file)"><font-awesome-icon :icon="['fas', 'image']"/></span>
                      <span @click.prevent="openPreview(file)"><font-awesome-icon :icon="['fa', 'search']"/></span>
                      <span v-if="active === 'user'" @click.prevent="confirmDelete(file, 'file')"><font-awesome-icon
                        :icon="['far', 'trash-alt']"/></span>
                    </div>
                  </div>
                  <div class="image-bg" v-bind:style="{
                                  'background-image': 'url(' + getUrl(file) +')',
                                }"></div>
                  <span
                    class="title-image">{{ file.name.length > 30 ? file.name.substring(0,30) + '...' : file.name  }}</span>
                </div>
              </div>

              <div class="files-container-content-image list-view"
                   v-if="active === tab.name && filters.typeView === 'th-list' && filesFilter.length !== 0">
                <div class="files-container-content--box-image-list"
                     v-for="(file, index) in filesFilter" v-if="index <= tab.limitImage" :key="index"
                     :class="{'is-selected' : filesSelected.indexOf(file.id) > -1 }"
                     @click="chooseImage(index, file, $event)">
                  <div class="files-container-content--box-image-content">
                    <div class="image-bg" v-bind:style="{'background-image': 'url(' + getUrl(file) +')'}"></div>
                    <span>{{ file.name.length > 30 ? file.name.substring(0,30) + '...' : file.name  }}</span>
                  </div>
                  <div class="files-container-content--box-image-options">
                          <span v-if="active === 'user'" @click.prevent="editFile(file)"><font-awesome-icon
                            :icon="['far', 'edit']"/></span>
                    <span @click.prevent="openPreview(file)"><font-awesome-icon :icon="['fa', 'search']"/></span>
                    <span v-if="active === 'user'" @click.prevent="confirmDelete(file, 'file')"><font-awesome-icon
                      :icon="['far', 'trash-alt']"/></span>
                  </div>
                </div>
              </div>

              <div class="files-container-content--box-image-empty-box"
                   v-else-if="filesFilter.length === 0 && filters.search">
                <font-awesome-icon :icon="['fas', 'photo-video']" class="icon-empty"/>
                <p>{{ $t('ct-directory-image-search-not-found')}}</p>
              </div>

              <div class="files-container-content--box-image-empty-box" v-else-if="filesFilter.length === 0">
                <font-awesome-icon :icon="['fas', 'photo-video']" class="icon-empty"/>
                <p>{{ $t('ct-directory-image-is-empty')}}</p>
              </div>

            </div>

          </div>

        </div>
        <!-- CONTAINER IMAGES - END -->

        <!-- FOOTER - BEGIN -->
        <div class="files-container-footer">
           <p class="file-alert mb-0 mx-1" v-if="filesSelected.length === 0 || filesSelected.length === this.choose"></p>
           <p class="file-alert-lenght-file mb-0 mx-1" v-else-if="filesSelected.length > 0 && filesSelected.length > this.choose"> {{ $t('ct-files-selected-length-more-max')}} {{ this.choose }}</p>
           <p class="file-alert-lenght-file mb-0 mx-1" v-if="filesSelected.length > 0 && this.choose > 1"> {{ $t('ct-files-selected-length')}} ({{ this.filesSelected.length }}/{{choose}})</p>
          <button class="btn btn-cancel" @click.prevent="cancel">{{ $t('ct-cancel')}}</button>
          <button class="btn btn-confirm"
                  :class="{'disabled': filesSelected.length === 0 || filesSelected.length > 0 && filesSelected.length > this.choose}"
                  @click.prevent="confirm">
                  <i class="svg-icon svgi-save"></i>
                  {{ $t('ct-save')}}
          </button>
        </div>
        <!-- FOOTER - END -->

      </div>
    </modal-component>

    <modal-delete-component
      :show="modal.delete.show"
      :values="modal.delete.config"
      @cancel="cancelDelete"
      style="z-index: 10050"
      @exclude="deleteAction">
      <div slot="content" v-if="modal.delete.config.controller"> {{ $t(`ct-${modal.delete.config.controller}-name`)}}:
        {{modal.delete.config.name}}
        {{modal.delete.config.files? Object.keys(modal.delete.config.files).map(value => `${modal.delete.config.files[value].name}`).join(', ') : ''}}
      </div>
    </modal-delete-component>

    <sweet-modal style="z-index: 10050" :title=" modals.item ? $t(`ct-${typePopUp.toLowerCase()}-${modals.item}-${modals.type}`) : ''"
                 ref="file" width="25%" class="sweet-modal-theme-cheetah" hide-close-button blocking >
      <form>
        <div class="form-group">
          <label for="name">{{ $t('ct-name') }}</label>
          <input
            type="text"
            class="form-control"
            name="name"
            v-model="file.name"
            minlength="3"
            maxlength="100"
            :class="{ 'is-invalid': errors.has('file.name')}"
            @keyup="errors.clear('file.name')"
            required
          />
          <span
            v-if="errors.has('file.name')"
            class="invalid-feedback"
            v-text="errors.get('file.name')"
          ></span>
        </div>
      </form>

      <button
        slot="button"
        class="btn btn-outline-light mt-2"
        @click.prevent="cancelDirectoryOrFile"
      >{{ $t('ct-cancel')}}
      </button>
      <button
        slot="button"
        class="btn btn-success mt-2"
        @click.prevent="confirmDirectoryOrFile"
      ><i class="svg-icon svgi-save"></i>{{ $t('ct-save')}}
      </button>
    </sweet-modal>

    <sweet-modal style="z-index: 10050" ref="create" width="25%" class="sweet-modal-theme-cheetah" :title=" modals.item ? $t(`ct-${modals.item}-${modals.type}`) : ''"
                 hide-close-button blocking>
      <div v-if="modals.item === 'directory'">
        <form>
          <div class="form-group">
            <label for="name">{{ $t('ct-name') }}</label>
            <input
              type="text"
              class="form-control"
              name="name"
              v-model="directory.name"
              minlength="3"
              maxlength="100"
              :class="{ 'is-invalid': errors.has('directory.name')}"
              @keyup="errors.clear('directory.name')"
              required
            />
            <span
              v-if="errors.has('directory.name')"
              class="invalid-feedback"
              v-text="errors.get('directory.name')"
            ></span>
          </div>
        </form>
      </div>

      <button
        slot="button"
        class="btn btn-outline-light mt-2"
        @click.prevent="cancelDirectoryOrFile"
      >{{ $t('ct-cancel')}}
      </button>
      <button
        slot="button"
        class="btn btn-success mt-2"
        @click.prevent="confirmDirectoryOrFile"
      ><i class="svg-icon svgi-save"></i>{{ $t('ct-save')}}
      </button>
    </sweet-modal>

    <modal-component style="z-index: 10050" ref="moveFile" width="32%" minWidth="400px" header="true" :title="$t('ct-move-files')">
      <div slot="body" class="files-move-body">
        <div class="files-move-container">
          <div class="files-move-container-navbar">
            <ul class="files-move-list-navbar">
              <li @click.prevent="openDirectorySelected()" :class="{'disabled': directorySelected }">
                <!--                <font-awesome-icon v-if="!directorySelected" :icon="['fas', 'folder-open']"/>-->
                <i class="icon ct-icon-folder-open"/>
                <!--                <i class="icon ct-icon-folder" v-else/>-->
                <!--                <font-awesome-icon v-else :icon="['fas', 'folder']"/>-->
                <span>{{ $t('ct-my-files')}}</span>
                <font-awesome-icon v-if="directorySelected" :icon="['fas', 'chevron-right']" class="separator"/>
              </li>
              <li v-if="directorySelected">
                <font-awesome-icon :icon="['fas', 'folder-open']"/>
                <span>{{ directorySelected.name }}</span>
              </li>
            </ul>
          </div>

          <template v-if="!directorySelected">
            <div class="files-move-container-choose-folder">
              <ul class="files-move-list-choose-folder">
                <li v-for="(directory, index) in tabActive.directories" :key="index"
                    @click.prevent="openDirectorySelected(directory)">
                  <!--                  <font-awesome-icon :icon="['fas', 'folder']"/>-->
                  <i class="icon ct-icon-folder"/>
                  <span>{{ directory.name }}</span>
                </li>
              </ul>
            </div>
          </template>
        </div>

        <div v-if="directorySelected" class="files-move-container-folder-files">
          <div class="files-move-folter-container-box-image">
            <div class="files-move-folter-container-box-image">
            </div>
          </div>
        </div>

      </div>

      <div slot="footer" class="files-move-footer" :class="{'with-new-folder': !directorySelected }">

        <button
          v-if="!directorySelected"
          class="btn btn-y-lg btn-new-directory"
          @click.prevent="newDirectory(true)"
        >
          <i class="icon ct-icon-folder-plus mr-2"/> {{ $t('ct-new-directory')}}
        </button>

        <div>
          <button
            class="btn btn-y-lg btn-light"
            @click.prevent="closeMoveFiles"
          >{{ $t('ct-cancel')}}
          </button>

          <button
            class="btn btn-y-lg btn-primary"
            @click.prevent="confirmMoveFiles"
          >{{ $t('ct-move')}}
          </button>

        </div>

      </div>

    </modal-component>

    <sweet-modal style="z-index: 10050" :title="`${$t('ct-toast-editor-image')} -  ${editorToastUI.data.name}`" ref="editor-image" width="80%" height="80%" class="sweet-modal-theme-cheetah toast-editor-image" hide-close-button blocking>

      <div ref="tuiImageEditor"></div>

      <button
        slot="button"
        class="btn btn-outline-light mt-2"
        @click.prevent="$refs['editor-image'].close()"
      >{{ $t('ct-cancel')}}
      </button>
      <button
        slot="button"
        class="btn btn-success mt-2"
        @click.prevent="saveImage"
      >{{ $t('ct-save')}}
      </button>
    </sweet-modal>
  </div>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';
import ModalComponent from '../Modal';
import ModalDeleteComponent from './../../dashboard/components/ModalDelete';
import PreviewComponent from './Preview';
import {
  getImages, uploadImage
} from './../../../js/services/editor/externalImage';
import {
  edit as editDirectory,
  getSystemFiles, getUserFiles, create as createDirectory,
  getAll as getAllDirectories,
  exclude as excludeDirectory
} from './../../../js/services/files/directory';
import {
  moveFiles,
  removeDirectoryFile,
  edit as editFile,
  exclude as excludeFile,
  excludeMultiple as excludeMultipleFiles
} from './../../../js/services/files/file';
import FileUpload from 'v-file-upload';
import {mapGetters} from 'vuex';
import Data from './data';

import TUIImageEditor from './toast-ui/TUIImageEditor.js';

import axios from 'axios';
require('./FileManager.scss');
require('./toast-ui/tui-color-picker.css');
require('./toast-ui/tui-image-editor.css');
require('./toast-ui/tui-image-editor-style.css');

export default {
  name: 'ModalFiles',
  props: ['show', 'type', 'module', 'maxSelectedFiles'],
  components: {
    SweetModal, ModalComponent, ModalDeleteComponent, FileUpload, PreviewComponent
  },

  data() {
    return new Data().data;
  },

  watch: {
    show: function(value) {
      this.modalShow = !!value;
    }
  },

  methods: {
    ...mapGetters({getFilesManager: 'filesManager'}),
    formatAndSetVuex() {
      this.$store.commit('filesManager', {...this.filtesFormatVuex});
    },

    removeFilePreview(file) {
      this.filesPreview = this.filesPreview.filter((fileThis) => fileThis.index !== file.index);
    },

    async onChangeFile() {
      var elemente = this.$refs['input-files'];

      var lengthfiles = elemente.files.length;

      if (lengthfiles > 25) {
        lengthfiles = 25;
        this.$snotify.warning(this.$t(`ct-upload-files-warning-max-20`), {
          position: 'centerTop'
        });
      }

      for (var i = 0; i < lengthfiles; i++) {
        var file = elemente.files[i];

        let fileObj = {
          name: file.name,
          base64: false,
          uploadPercentage: 10,
          error: false,
          size: file.size
        };

        var vm = this;

        fileObj.index = vm.filesPreview.length;

        vm.filesPreview.push(fileObj);

        if (file.type.match('image.*')) {
          var reader = new FileReader();

          reader.onload = (function(theFile) {
            return function(e) {
              // thumbnail image
              if (vm.filesPreview[fileObj.index]) { vm.$set(vm.filesPreview[fileObj.index], 'base64', e.target.result) }
            };
          })(file);

          await reader.readAsDataURL(file);
        } else {
          let thumb = 'https://www.omb11.com/app_current/js/editor-html/Base/Files/Uploader/assets/images/icon_undefined.png';
          if (vm.filesPreview[fileObj.index]) { vm.$set(vm.filesPreview[fileObj.index], 'base64', thumb) }
        }

        if (file.name.length > 100) {
          fileObj.error = this.$t(`ct-upload-${this.typePopUp.toLowerCase()}-maxname`);
          fileObj.uploadPercentage = false;
          continue;
        }

        if (file.size >= this.accept.max_size) {
          fileObj.error = this.$t(`ct-upload-${this.typePopUp.toLowerCase()}-maxfile`);
          fileObj.uploadPercentage = false;
          continue;
        }

        let data = new FormData();
        data.append('file', elemente.files[i]);

        var token = localStorage.getItem('token')
          ? localStorage.getItem('token')
          : '';

        const options = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
          },
          onUploadProgress: (progressEvent) => {
            const {loaded, total} = progressEvent;
            let percent = Math.floor((loaded * 100) / total);
            vm.$set(vm.filesPreview[fileObj.index], 'uploadPercentage', percent);
          }
        };

        let url = await this.getURLUpload();

        axios.post(url, data, options)
          .then(async res => {
            if (res.data.success) {

              vm.tabsFolders[0].files.unshift(res.data.data);

              let filesR = vm.tabsFolders[0].files;

              vm.$set(vm.tabsFolders[0], 'files', filesR);

              vm.updateFilesFilter();

              await setTimeout(() => {
              }, 100);

              this.filesPreview = this.filesPreview.filter((fileThis) => fileThis.index !== fileObj.index);
            } else {
              fileObj.error = this.$t('ct-success-false');
              fileObj.uploadPercentage = false;
            }
          })
          .catch(() => {
            fileObj.error = this.$t('ct-success-false');
            fileObj.uploadPercentage = false;
          });
      }

      await setTimeout(() => {}, 200);
      elemente.value = '';
    },

    onError(error) {
      if (error.target && error.target.response && !error.target.response.success && error.target.response.validator) {
        this.$snotify.warning(this.$t(`ct-upload-${this.typePopUp.toLowerCase()}-maxfile`), {
          position: 'centerTop'
        });
      } else {
        this.$snotify.error(this.$t('ct-success-false'), {
          position: 'centerTop'
        });
      }
    },
    beforeUploadFile(response) {
      if (response.target && response.target.response && response.target.response.success && response.target.response.data) {
        switch (this.typePopUp) {
          case 'Files':
            this.getUserFiles(true);
            break;
          case 'Videos':
            this.getUserVideos(true);
            break;
          default :
            this.getUserImages(true);
            break;
        }
      } else {
        this.$snotify.error(this.$t('ct-success-false'), {
          position: 'centerTop'
        });
      }
    },

    getType() {
      return this.type ? this.type : this.defaultValues.type;
    },

    getURLUpload() {
      let url = '';

      if (typeof process.env.API_URL !== 'undefined') {
        url = process.env.API_URL
      } else if (process.env.NODE_ENV === 'development') {
        url = 'http://api.localhost';
      } else {
        url = 'https://cheetah-api.builderall.com';
      }

      this.optionsUpload = this.options.options[this.typePopUp.toLowerCase()];

      let params = '';

      if (this.tabActive.directoryActive && this.tabActive.directoryActive !== 'all') { params = `?id_directory=${this.tabActive.directoryActive}` }

      return `${url}/api${this.optionsUpload.action}${params}`;
    },

    openTabFile() {
      this.$refs.modalfilesfile.open();
    },

    closeFile() {
      this.$refs.modalfilesfile.close();
    },
    save(file) {
      this.value = {src: file.path + '/' + file.file, name: file.name};
    },
    close() {
      this.$refs.modalFileMananger.close();
    },

    open() {
      this.init();
      this.$refs.modalFileMananger.showModal();
    },

    cancel() {
      this.close();
      this.modalShow = false;
      this.$emit('close');
    },

    async confirm() {
      if (this.filesSelected.length === 0 || (this.filesSelected.length > 0 && this.filesSelected.length > this.choose)) { return }
      this.$emit('confirm', this.choose === 1 ? this.filesSelectedList[0] : this.filesSelectedList);
      this.$loading.show();
      await this.cancel();
      setTimeout(() => this.$loading.hide(), this.choose === 1 ? 300 : 800);
    },

    reset() {
      this.filesSelected = [];
      this.filesSelectedList = [];

      this.filtesFormatVuex = {
        Files: {},
        Images: {},
        Videos: {}
      };

      this.tabsFolders = [];
    },

    editorImage(file) {
      this.$loading.show();
      // let url = 'static/images/vimeo.png';
      let url = 'https://omb11.com/' + file.path + '/' + file.file;
      let urlUpload = this.getURLUpload();

      this.editorToastUI = new TUIImageEditor(this.$refs.tuiImageEditor, urlUpload, this, {url: url, name: file.name});

      setTimeout(() => this.$loading.hide(), 500);
      this.$refs['editor-image'].open();
    },

    saveImage() {
      let vm = this;

      this.editorToastUI.imageEditor.stopDrawingMode();

      this.editorToastUI.onSave(
        (response) => {
          // vm.$refs['editor-image'].close();

          if (response.success && response.data) {
            this.getUserImages(true);
          } else {
            this.$snotify.error(this.$t('ct-success-false'), {
              position: 'centerTop'
            });
          }
        }
      );
    },

    init() {
      let type = this.type ? this.type : this.defaultValues.type;

      let vuex = this.getFilesManager();
      this.typePopUp = this.type;

      this.optionsUpload = this.options.options[this.typePopUp.toLowerCase()];
      this.accept[this.typePopUp] = this.optionsUpload.accept();
      this.accept.accept = this.optionsUpload.accept();
      this.accept.max_size = this.optionsUpload.max_size;
      this.choose = this.maxSelectedFiles;

      this.reset();
      this.requestTabs(vuex);
    },

    getActiveTab(tab) {
      if (this.$refs['list-' + tab.name]) {
        this.$refs['list-' + tab.name][0].classList.add('active');
      }

      if (this.$refs['directory-' + tab.directoryActive]) {
        this.$refs['directory-' + tab.directoryActive].classList.add('active');
      }
    },

    requestTabs(vuex) {
      if (Object.keys(vuex[this.typePopUp]).length === 0 && vuex[this.typePopUp].constructor === Object) {
        switch (this.typePopUp) {
          case 'Files':
            this.getUserFiles();
            break;
          case 'Videos':
            this.getUserVideos();
            break;
          default :
            this.getUserImages();
            break;
        }

        this.getActiveTab(this.tabActive);
      } else {
        Object.values(vuex[this.typePopUp]).forEach(value => {
          this.createTabFiles(value);
        });

        let module_user = vuex[this.typePopUp]['User'];
        module_user.name = module_user.name.toLowerCase();
        module_user.limitImage = 25;
        module_user.directoryActive = 'all';

        this.chooseTab('user', module_user);

        this.getActiveTab(this.tabActive);
        // this.updateFilesFilter();
      }
    },

    getUserFiles(update = false) {
      this.$loading.show();

      getUserFiles('Files')
        .then(data => {
          let systemUser = data.data;
          let module_user = systemUser.images;
          module_user.name = 'User';

          if (update) {
            this.filtesFormatVuex[this.typePopUp]['User'] = {...module_user};

            module_user.name = module_user.name.toLowerCase();
            module_user.limitImage = 25;
            module_user.directoryActive = 'all';

            this.tabsFolders[0] = module_user;

            this.loadTabUser(systemUser, update);

            this.formatAndSetVuex();

            // if (this.active === 'user') {
            //     this.chooseTab(module_user.name, module_user);
            // }

            this.updateFilesFilter();

            this.$loading.hide();
          }

          if (!update) { this.createTabFiles(module_user) }

          this.data.user.files = systemUser.images;

          this.$loading.hide();
        })
        .catch(error => {
          console.warn(error);
          this.$loading.hide();
          this.$snotify.error(this.$t('ct-success-false'), {
            position: 'centerTop'
          });
        });
    },

    getUserVideos(update = false) {
      this.$loading.show();

      getUserFiles('Videos')
        .then(data => {
          let systemUser = data.data;
          let module_user = systemUser.images;
          module_user.name = 'User';

          if (update) {
            this.filtesFormatVuex[this.typePopUp]['User'] = {...module_user};

            module_user.name = module_user.name.toLowerCase();
            module_user.limitImage = 25;
            module_user.directoryActive = 'all';

            this.tabsFolders[0] = module_user;

            this.formatAndSetVuex();

            if (this.active === 'user') {
              this.chooseTab(module_user.name, module_user);
            }

            this.updateFilesFilter();

            this.$loading.hide();
          }

          if (!update) { this.createTabFiles(module_user) }

          this.$loading.hide();

          this.formatAndSetVuex();
        })
        .catch(error => {
          console.warn(error);
          this.$loading.hide();
          this.$snotify.error(this.$t('ct-success-false'), {
            position: 'centerTop'
          });
        });
    },

    loadTabUser(response, update) {
      let module_user = response.images;
      module_user.name = 'User';

      if (update) {
        this.filtesFormatVuex[this.typePopUp]['User'] = {...module_user};

        module_user.name = module_user.name.toLowerCase();
        module_user.limitImage = 25;
        module_user.directoryActive = this.tabActive.directoryActive !== 'all' ? this.tabActive.directoryActive : 'all';

        this.tabsFolders[0] = module_user;

        this.formatAndSetVuex();

        if (this.active === 'user') {
          this.chooseTab(module_user.name, module_user);
        }

        this.updateFilesFilter();
      }

      if (!update) { this.createTabFiles(module_user) }

      this.formatAndSetVuex();
    },

    loadTabSystem(response, update, vm) {
      if (!update) {
        let systemFiles = response;

        if (systemFiles.success) {
          [].forEach.call(systemFiles.data, function(el) {
            if (el && el.success) {
              let module_item = el.modules[0];

              vm.createTabFiles(module_item);
            }
          });
        }

        this.formatAndSetVuex();
      }
    },

    getUserImages(update = false) {
      this.$loading.show();

      Promise.all([getUserFiles(), getSystemFiles(['Images', 'Icons', 'Buttons', 'Gifs'])])
        .then(async data => {
          let user_response = data[0].data;
          let system_response = data[1].data;

          if (user_response) {
            await this.loadTabUser(user_response, update);
          }

          if (system_response) {
            await this.loadTabSystem(system_response, update, this);
          }
        })
        .catch(error => {
          console.warn(error);
        })
        .finally(() => this.$loading.hide());
    },

    handleScroll(evt, el) {
      let isUserScrolling = (evt.target.scrollTop > 0);

      if (isUserScrolling) {
        // let container = this.$refs.containerContent;
        let container = evt.target;
        var vm = this;

        if (container.scrollHeight - container.scrollTop < 200 + container.offsetHeight) {
          this.tabsFolders.forEach((element, index) => {
            if (element.name === vm.active) {
              vm.tabsFolders[index].limitImage += 18;
            }
          });
        }
      }
    },

    getUrl(file, string = true) {
      var url = '';

      if (this.typePopUp === 'Images') {
        if (file.hasThumb && file.ext != 'gif') {
          url = file.thumbPath ? file.thumbPath : file.path + '/thumb/' + file.file;
        } else {
          url = file.path + '/' + file.file;
        }

        url = string ? "'https://storage.builderall.com/" + url + "'" : 'https://storage.builderall.com/' + url;
      } else if (this.typePopUp === 'Files') {
        var icon = 'icon_undefined.png';
        var types = this.options.mimetypes.getMimeType('file');

        for (var i in types) {
          if (types[i].includes(file.mimetype)) {
            if (i === 'image') {
              if (file.hasThumb) {
                url = file.thumbPath ? file.thumbPath : file.path + '/thumb/' + file.file;
              } else {
                url = file.path + '/' + file.file;
              }

              url = 'https://www.omb11.com/' + url;
            } else {
              icon = 'icon_' + i + '.ico';
              url = 'https://www.omb11.com/app_current/js/editor-html/Base/Files/Uploader/assets/images/' + icon;
            }
          }
        }
      } else if (this.typePopUp === 'Videos') {
        if (!url) { url = 'https://www.omb11.com/app_current/js/editor-html/Base/Files/Uploader/assets/images/icon_undefined.png' }
      }
      if (!url) { return 'https://www.omb11.com/app_current/js/editor-html/Base/Files/Uploader/assets/images/icon_undefined.png' }

      if(url.includes('undefined')){
        return 'https://www.omb11.com/app_current/js/editor-html/Base/Files/Uploader/assets/images/icon_undefined.png'
      }

      return url;
    },

    createTabFiles(config) {
      this.filtesFormatVuex[this.typePopUp][config.name] = {...config};
      config.name = config.name.toLowerCase();
      config.limitImage = 25;
      config.directoryActive = 'all';

      if (config.name === 'user') {
        this.chooseTab(config.name, config);
      }

      this.tabsFolders.push(config);
    },

    chooseTab(tabActive, tab) {
      this.active = tabActive;
      tab.name = tab.name.toLowerCase();
      tab.limitImage = 25;
      // tab.directoryActive = 'all';
      this.tabActive = tab;
      this.$refs.containerContent.scrollTop = 0;

      this.updateFilesFilter();
    },

    filterDirectories(files, idDirectory = '') {
      let filesR = [...files];

      if (this.filters.order === 'asc' || this.filters.order === 'desc') {
        filesR = filesR.sort(function(a, b) {
          return a.name.localeCompare(b.name);
        });

        if (this.filters.order === 'desc') {
          filesR.reverse();
        }
      }

      let vm = this;
      let search = vm.filters.search;
      let directory = idDirectory || this.tabActive.directoryActive;

      if (this.tabActive.directoryActive !== 'all') {
        let idDirectory = idDirectory || this.tabActive.directoryActive;

        if (idDirectory) {
          filesR = filesR.filter(function(file) {
            if (search) { return idDirectory === file.id_directory && file.name.indexOf(search) > -1 } else { return idDirectory === file.id_directory }
          });
        }
      } else if (search) {
        filesR = filesR.filter(function(file) {
          return file.name.indexOf(search) > -1;
        });
      }

      return filesR;
    },

    changeDirectories(directory) {
      this.activeDirectory = directory;
      this.tabActive.directoryActive = directory;

      this.$refs.containerContent.scrollTop = 0;
      this.removeSelected();

      this.updateFilesFilter();
    },

    cancelDirectoryOrFile() {
      this.modals = {
        type: '',
        item: ''
      };

      this.directory = {
        id_directory: '',
        id_uploader_module: '', // 1 -	Images , 2 -	Videos,  3 - Files
        type_module: 'Images',
        name: ''
      };

      this.file = {
        name: ''
      };

      this.$refs.create.close();
      this.$refs.file.close();

      if (this.byMove) { this.$refs.moveFile.open() }
    },

    confirmDirectoryOrFile() {
      if (this.modals.item === 'directory') {
        if (this.modals.type === 'create') {
          this.directoryCreateSave();
        } else if (this.modals.type === 'edit') {
          this.directoryEditSave();
        }
      } else if (this.modals.item === 'file') {
        this.fileEditSave(this.modals.config);
      }
    },

    fileEditSave(file) {
      this.$loading.show();

      editFile(file)
        .then(response => {
          if (response.data.success) {
            Object.keys(this.tabsFolders[0].files).forEach(index => {
              if (this.tabsFolders[0].files[index].id === file.id) {
                this.tabsFolders[0].files[index].name = file.name;
              }
            });

            this.filtesFormatVuex[this.typePopUp]['User'].files = this.tabsFolders[0].files;
            this.formatAndSetVuex();
            this.updateFilesFilter();

            this.$snotify.success(`${this.$t('ct-file')} ${this.$t('ct-edited')} ${this.$t('ct-with-success')}`, {
              position: 'centerTop'
            });

            this.$refs.file.close();
          } else {
            if (response.data.validator) { this.errors.record({file: response.data.errors}) }

            this.$snotify.error(this.$t('ct-success-false'), {
              position: 'centerTop'
            });
          }
          this.$loading.hide();
        })
        .catch(error => {
          this.$loading.hide();
          this.$snotify.error(this.$t('ct-success-false'), {
            position: 'centerTop'
          });
        });
    },

    editFile(file) {
      this.file = {...file};

      this.modals = {
        type: 'edit',
        item: 'file',
        config: this.file
      };

      this.$refs.file.open();
    },

    newDirectory(move = false) {
      this.modals = {
        type: 'create',
        item: 'directory'
      };

      this.directory.type_module = this.typePopUp;

      this.byMove = move;

      if (this.byMove) { this.$refs.moveFile.close() }

      this.$refs.create.open();
    },

    editDirectory(directory) {
      this.modals = {
        type: 'edit',
        item: 'directory'
      };

      this.directory = {...directory};
      this.directoryisEditing = directory.id;

      this.$refs.create.open();
    },

    cancelDelete() {
      this.modal.delete = {
        show: false,
        config: {}
      };
    },

    confirmDelete(data, controller) {
      if (controller === 'files') {
        if (this.filesSelected.length === 0) { return }
      }

      this.modal.delete = {
        show: true,
        config: {...data, ...{controller: controller}}
      };
    },

    deleteAction(config) {
      this.$loading.show();

      if (config.controller === 'directory') {
        let directory = config;

        excludeDirectory(directory)
          .then(response => {
            if (response.data.success) {
              this.tabsFolders[0].directories = this.tabsFolders[0].directories.filter(function(directory_this) {
                return directory_this.id !== directory.id;
              });

              this.updateFilesFilter();

              this.$snotify.success(`${this.$t('ct-directory')} ${this.$t('ct-deleted')} ${this.$t('ct-with-success')}`, {
                position: 'centerTop'
              });
            } else {
              this.$snotify.error(this.$t('ct-success-false'), {
                position: 'centerTop'
              });
            }

            this.cancelDelete();
            this.$loading.hide();
          })
          .catch(error => {
            this.$loading.hide();
            this.$snotify.error(this.$t('ct-success-false'), {
              position: 'centerTop'
            });
          });
      } else if (config.controller === 'file') {
        excludeFile(this.filesSelected)
          .then(response => {
            if (response.data.success) {
              this.tabsFolders[0].files = this.tabsFolders[0].files.filter(function(file_this) {
                return file_this.id !== config.id;
              });

              this.$snotify.success(`${this.$t('ct-file')} ${this.$t('ct-deleted')} ${this.$t('ct-with-success')}`, {
                position: 'centerTop'
              });

              this.updateFilesFilter();
            } else {
              this.$snotify.error(this.$t('ct-success-false'), {
                position: 'centerTop'
              });
            }

            this.cancelDelete();
            this.$loading.hide();
          })
          .catch(error => {
            this.$loading.hide();
            this.$snotify.error(this.$t('ct-success-false'), {
              position: 'centerTop'
            });
          });
      } else if (config.controller === 'files') {
        let data = {
          id_file: this.filesSelected
        };

        excludeMultipleFiles(this.filesSelected)
          .then(response => {
            if (response.data.success) {
              if (this.typePopUp === 'Files') {
                this.getUserFiles(true);
              } else if (this.typePopUp === 'Videos') {
                this.getUserVideos(true);
              } else {
                this.getUserImages(true);
              }

              this.cancelDelete();
              this.$loading.hide();

              this.$snotify.success(this.$t('ct-success-true'), {
                position: 'centerTop'
              });
            } else {
              this.$snotify.error(this.$t('ct-success-false'), {
                position: 'centerTop'
              });
            }
          })
          .catch(error => {
            this.$snotify.error(this.$t('ct-success-false'), {
              position: 'centerTop'
            });
          });
      }
    },

    directoryCreateSave() {
      this.$loading.show();

      createDirectory(this.directory)
        .then(response => {
          if (response.data.success) {
            let directory = response.data.data;
            directory.id = directory.id_directory;

            this.tabsFolders[0].directories.push(directory);
            this.updateFilesFilter();
            this.errors.clear();

            this.$snotify.success(`${this.$t('ct-directory')} ${this.$t('ct-created')} ${this.$t('ct-with-success')}`, {
              position: 'centerTop'
            });

            this.updateFilesFilter();
            this.cancelDirectoryOrFile();
            this.$refs.create.close();
          } else {
            if (response.data.validator) { this.errors.record({directory: response.data.errors}) } else { this.cancelDirectoryOrFile() }

            this.$snotify.error(this.$t('ct-success-false'), {
              position: 'centerTop'
            });
          }

          this.$loading.hide();
        })
        .catch(error => {
          this.$loading.hide();
          this.$snotify.error(this.$t('ct-success-false'), {
            position: 'centerTop'
          });
        });

      // todo adicionar diretorio na lista depois de criado (data.user.directories)
      if (this.byMove) {
        this.$refs.moveFile.open();
        this.byMove = false;
      }
    },

    directoryEditSave() {
      this.$loading.show();

      editDirectory(this.directory)
        .then(response => {
          if (response.data.success) {
            var vm = this;

            Object.keys(this.tabsFolders[0].directories).forEach(index => {
              if (this.tabsFolders[0].directories[index].id === vm.directory.id) {
                this.tabsFolders[0].directories[index].name = vm.directory.name;
              }
            });

            this.filtesFormatVuex[this.typePopUp]['User'].directories = this.tabsFolders[0];
            this.formatAndSetVuex();
            this.updateFilesFilter();
            this.cancelDirectoryOrFile();

            this.$snotify.success(`${this.$t('ct-directory')} ${this.$t('ct-edited')} ${this.$t('ct-with-success')}`, {
              position: 'centerTop'
            });

            this.errors.clear();
          } else {
            if (response.data.validator) { this.errors.record({directory: response.data.errors}) }

            this.$snotify.error(this.$t('ct-success-false'), {
              position: 'centerTop'
            });
          }

          this.$loading.hide();
        })
        .catch(error => {
          this.$loading.hide();
          this.$snotify.error(this.$t('ct-success-false'), {
            position: 'centerTop'
          });
        });
    },

    removeSelected() {
      this.filesSelected = [];
      this.filesSelectedList = [];
    },

    removeSelectedFile(file) {
      this.filesSelected = this.filesSelected.filter(e => e !== file.id);
      this.filesSelectedList = this.filesSelectedList.filter(fileSelected => fileSelected.id !== file.id);
    },

    getIsCrtl(file) {
      return !!this.filesSelectedList.find(fileSelected => fileSelected.id === file.id && file.ctrl);
    },

    clearCtrl(files) {
      Object.keys(files).forEach(index => files[index].ctrl = false);
    },

    chooseImage(index, file, event) {
      var ctrl = event.metaKey || event.ctrlKey;
      var shift = event.shiftKey;
      let findInSelected = this.filesSelectedList.find(fileSelected => fileSelected.id === file.id) && this.filesSelected.filter(e => e === file.id);

      if (ctrl) {
        if (findInSelected) {
          file.ctrl = false;
          this.removeSelectedFile(file);
        } else {
          file.ctrl = true;
          this.filesSelected.push(file.id);
          this.filesSelectedList.push(file);
        }
      } else if (this.choose > 1) {
        this.clearCtrl(this.filesFilter);

        if (findInSelected) {
          this.removeSelectedFile(file);
        } else {
          this.filesSelected.push(file.id);
          this.filesSelectedList.push(file);
        }
      } else {
        this.clearCtrl(this.filesFilter);

        if (findInSelected && this.filesSelected.length > this.choose) {
          this.removeSelectedFile(file);
          this.filesSelected = this.filesSelected.filter(e => e === file.id);
          this.filesSelectedList = this.filesSelectedList.filter(fileSelected => fileSelected.id === file.id);
        } else {
          if (!this.filesSelected.includes(file.id)) {
            this.filesSelected = this.filesSelected.filter(e => e === file.id);
            this.filesSelectedList = this.filesSelectedList.filter(fileSelected => fileSelected.id === file.id);
          }
        }
        // without press key
        if (!this.filesSelected.includes(file.id)) {
          this.filesSelected.push(file.id);
          this.filesSelectedList.push(file);
        }
      }

      if (this.filesSelected.length > 0) {
        this.canMoveFiles = true;
      }
    },

    openMoveFiles() {
      if (this.canMoveFiles && this.filesSelected) {
        if (this.tabActive.directoryActive !== 'all') {
          let directoryActive = this.tabActive.directoryActive;
          this.directorySelected = this.tabActive.directories.find(directory => directory.id === directoryActive);
        }
        this.$refs.moveFile.open();
      }
    },

    closeMoveFiles() {
      this.directorySelected = false;
      this.$refs.moveFile.close();
    },

    confirmMoveFiles() {
      this.$loading.show();
      // todo verificar se o arquivo ja esta no diretorio se sim remover do files selected
      if (this.directorySelected) {
        let data = {
          id_directory: this.directorySelected.id,
          files_ids: this.filesSelected
        };

        moveFiles(data)
          .then(response => {
            this.callbackMoveFile(response);
          })
          .catch(error => {
            this.$snotify.error(this.$t('ct-success-false'), {
              position: 'centerTop'
            });
          });
      } else {
        // Remove diretorios do arquivo
        let data = {
          files_ids: this.filesSelected
        };

        removeDirectoryFile(data)
          .then(response => {
            this.callbackMoveFile(response);
          })
          .catch(error => {
            this.$snotify.error(this.$t('ct-success-false'), {
              position: 'centerTop'
            });
          });
      }
    },

    callbackMoveFile(response) {
      if (response.data.success) {
        if (this.typePopUp === 'Files') {
          this.getUserFiles(true);
        } else if (this.typePopUp === 'Videos') {
          this.getUserVideos(true);
        } else {
          this.getUserImages(true);
        }

        this.closeMoveFiles();
        this.removeSelected();

        this.$snotify.success(`${this.$t('ct-file')} ${this.$t('ct-moved')} ${this.$t('ct-with-success')}`, {
          position: 'centerTop'
        });

        this.$loading.hide();
      } else {
        this.$snotify.error(this.$t('ct-success-false'), {
          position: 'centerTop'
        });
      }
    },

    openDirectorySelected(directory = '') {
      if (directory) { this.directorySelected = directory } else this.directorySelected = false;
    },

    searchFile() {
      this.updateFilesFilter();
    },

    updateFilesFilter() {
      this.filesFilter = this.filterDirectories(this.tabActive.files, this.tabActive.directoryActive);
    },

    setFilter(type, value, realod = false) {
      this.filters[type] = value;

      if (realod) { this.updateFilesFilter() }
    },

    openPreview(file, type = 'image') {
      this.previewFile = {
        // show: true,
        type: type,
        file: file
      };

      this.$refs.previewFile.open();
    }
  },

  created() {
  }
};

</script>



// WEBPACK FOOTER //
// src/components/general/FilesManager/FileManager.vue